"use strict";
var appn;
(function (appn) {
    var views;
    (function (views) {
        var folders;
        (function (folders) {
            var organise;
            (function (organise) {
                function init() {
                    const $appnForm = $('#appnForm');
                    appn.iframe.bindSubmitButtonsAndNavLinks($appnForm);
                    const selectedItems = parent.appn.folderFilter.selectedItems;
                    selectedItems.each(function (index) {
                        $appnForm.append('<input type="hidden" name="SelectedItems[' + index + ']" value="' + selectedItems[index].id + '" />');
                    });
                    var caller = window.parent.location.pathname;
                    if (caller.containsIgnoreCase('Screens') || caller.containsIgnoreCase('Forms'))
                        $appnForm.append('<input type="hidden" name="ItemType" value="Screen" />');
                    else if (caller.containsIgnoreCase('DocDefinitions'))
                        $appnForm.append('<input type="hidden" name="ItemType" value="Doc" />');
                    else if (caller.containsIgnoreCase('TaskTemplates'))
                        $appnForm.append('<input type="hidden" name="ItemType" value="TaskTemplate" />');
                    else if (caller.containsIgnoreCase('DataSources'))
                        $appnForm.append('<input type="hidden" name="ItemType" value="DataSource" />');
                    else if (caller.containsIgnoreCase('Dataset'))
                        $appnForm.append('<input type="hidden" name="ItemType" value="Dataset" />');
                    else if (window.parent.location.href.containsIgnoreCase('Dashboard'))
                        $appnForm.append('<input type="hidden" name="ItemType" value="Dashboard" />');
                    else if (window.parent.location.href.containsIgnoreCase('Sync'))
                        $appnForm.append('<input type="hidden" name="ItemType" value="Sync" />');
                    else
                        throw new Error('Unknown parent caller, cannot ascertain ItemType');
                }
                organise.init = init;
            })(organise = folders.organise || (folders.organise = {}));
        })(folders = views.folders || (views.folders = {}));
    })(views = appn.views || (appn.views = {}));
})(appn || (appn = {}));
